import * as RouteConstants from "./RouteConstants";
import * as CertificateBatchConstants from "./CertificateBatchConstants";
import * as AccessScopeConstants from "./AccessScopeConstants";

export const NOTIFICATION_USER_CREATION = "NOTIFICATION_USER_CREATION";
export const NOTIFICATION_PROGRAM_ASSIGNED = "NOTIFICATION_PROGRAM_ASSIGNED";
export const NOTIFICATION_PROGRAM_INCOMPLETE =
  "NOTIFICATION_PROGRAM_INCOMPLETE";
export const NOTIFICATION_PROGRAM_OVERDUE = "NOTIFICATION_PROGRAM_OVERDUE";
export const NOTIFICATION_PROGRAM_COMPLETED = "NOTIFICATION_PROGRAM_COMPLETED";
export const NOTIFICATION_CUSTOM = "NOTIFICATION_CUSTOM";
export const NOTIFICATION_CERTIFICATES_READY = "NOTIFICATION_CERTIFICATES_READY";

export const NOTIFICATION_TYPES = [
  {
    id: NOTIFICATION_USER_CREATION,
    value: 1,
    label: NOTIFICATION_USER_CREATION,
    severity: "info",
    summary: "New User Created",
  },
  {
    id: NOTIFICATION_PROGRAM_ASSIGNED,
    value: 2,
    label: NOTIFICATION_PROGRAM_ASSIGNED,
    severity: "info",
    summary: "Program Assigned",
  },
  {
    id: NOTIFICATION_PROGRAM_INCOMPLETE,
    value: 3,
    label: NOTIFICATION_PROGRAM_INCOMPLETE,
    severity: "warn",
    summary: "Program Incomplete",
  },
  {
    id: NOTIFICATION_PROGRAM_OVERDUE,
    value: 4,
    label: NOTIFICATION_PROGRAM_OVERDUE,
    severity: "error",
    summary: "Program Overdue",
  },
  {
    id: NOTIFICATION_PROGRAM_COMPLETED,
    value: 6,
    label: NOTIFICATION_PROGRAM_COMPLETED,
    severity: "success",
    summary: "Program Completed",
  },
  {
    id: NOTIFICATION_CUSTOM,
    value: 8,
    label: "Notification",
    severity: "info",
    summary: "Custom Notification",
  },
  {
    id: NOTIFICATION_CERTIFICATES_READY,
    value: CertificateBatchConstants.NOTIFICATION_TYPE_CERTIFICATES_READY,
    label: "certificate_batch_notification",
    // The text names the batch ({name}) and says how it ended (the API's
    // batchStatus); without a status (the batch is gone) only label is shown
    labelByStatus: {
      [CertificateBatchConstants.CERTIFICATE_BATCH_STATUS_READY]:
        "certificate_batch_notification_ready",
      [CertificateBatchConstants.CERTIFICATE_BATCH_STATUS_FAILED]:
        "certificate_batch_notification_failed",
    },
    severity: "info",
    summary: "Certificate download processed",
    to: RouteConstants.APP_ROUTE_CERTIFICATE_DOWNLOADS_LIST,
    linkLabel: "certificate_batch_view_downloads",
    // An admin page (Reports > Certificate downloads): the link switches to the
    // admin dashboard and is shown only to users whose role can read its list
    // (api/certificates/batches needs ReportAccess Read)
    dashboard: "admin",
    scope: AccessScopeConstants.ReportAccess,
    permission: AccessScopeConstants.ReadScope,
  },
];

// Shown for a notification type this version of the app does not know (a
// newer API can send new types), so the widget never breaks on one.
export const DEFAULT_NOTIFICATION_TYPE = {
  id: "NOTIFICATION_DEFAULT",
  value: null,
  label: "notification",
  severity: "info",
  summary: "Notification",
};

export const notificationTypeOf = (value) =>
  NOTIFICATION_TYPES.find((item) => item.value === value) ||
  DEFAULT_NOTIFICATION_TYPE;
